import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from 'src/app/core/utilities/util.service';
import { environment } from 'src/environments/environment';
import { LanguageService } from 'src/app/services/language.service';

declare var rspkr: any;
declare var ReadSpeaker: any;

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
})
export class HeaderMenuComponent extends BaseComponent implements OnInit {
  isShowSearchMenu: boolean = false;

  editProfileURL: string;

  readonly mainWebsiteLink = 'https://www.moccae.gov.ae/';
  readonly eServicesBaseLink = 'https://eservices.moccae.gov.ae';

  constructor(
    translateService: TranslateService,
    private languageService: LanguageService,
    public utilService: UtilService
  ) {
    super(translateService);

    this.editProfileURL = environment.editProfileUrl;
  }

  ngOnInit(): void {}

  logout(): void {
    this.utilService.logout();
  }

  showSearchBar(isShow: boolean) {
    this.isShowSearchMenu = isShow;
  }

  changeLanguage(lang: string) {
    try {
      if (ReadSpeaker.hl) {
        rspkr.hl.engine.textNode.clientExtension.postProcess.fullCleanUp();
      }
    } catch (error) {}

    this.languageService.changeLanguage(lang);
  }
}
